// import React, { useCallback, useState, useRef } from 'react';

// import './FormPhotoUploader.scss';

// import { FileUploader, FileUploaderTypes } from 'devextreme-react/file-uploader';

// export const FormPhotoUploader = () => {
//   const [isDropZoneActive, setDropZoneActive] = useState(false);

//   const uploaderZone = useRef();

//   const getUploaderRef = useCallback(
//     (element) => {
//       uploaderZone.current = element;
//     }, []);

//   const onDropZoneEvent = useCallback((e: FileUploaderTypes.DropZoneEnterEvent | FileUploaderTypes.DropZoneLeaveEvent) => {
//     if (e.dropZoneElement.id === 'uploader') {
//       setDropZoneActive(e.event?.type === 'dragenter');
//     }
//   }, []);

//   return (
//     <div>
//       <div
//         ref={getUploaderRef}
//         id='uploader'
//         className={`${ isDropZoneActive
//           ? 'dx-theme-accent-as-border-color'
//           : 'dx-theme-border-color' }`}
//       >
//         <span>Drag and drop a photo here or click the area to select it from a folder</span>
//       </div>
//       <FileUploader
//         dialogTrigger={uploaderZone.current}
//         dropZone={uploaderZone.current}
//         multiple={false}
//         accept='image/*'
//         uploadMode='instantly'
//         showFileList={false}
//         visible={false}
//         onDropZoneEnter={onDropZoneEvent}
//         onDropZoneLeave={onDropZoneEvent}
//       />
//     </div>
//   );
// };

import React, { useCallback, useState, useRef } from 'react';
import './FormPhotoUploader.scss';
import {
  FileUploader,
  FileUploaderTypes,
} from 'devextreme-react/file-uploader';
import { nameserver } from '../../../config/nameServer';
export const FormPhotoUploader = ({ onUploaded }) => {
  const [isDropZoneActive, setDropZoneActive] = useState(false);
  const [preview, setPreview] = useState('');
  const uploaderZone = useRef<HTMLDivElement | null>(null);

  // const getUploaderRef = useCallback((element) => {
  //   uploaderZone.current = element;
  // }, []);

  const onDropZoneEvent = useCallback(
    (
      e:
        | FileUploaderTypes.DropZoneEnterEvent
        | FileUploaderTypes.DropZoneLeaveEvent
    ) => {
      if (e.dropZoneElement.id === 'uploader') {
        setDropZoneActive(e.event?.type === 'dragenter');
      }
    },
    []
  );

  return (
    <div>
      <div
        ref={uploaderZone}
        id='uploader'
        className={`${isDropZoneActive
            ? 'dx-theme-accent-as-border-color'
            : 'dx-theme-border-color'
          }`}
      >
        <span>Chụp ảnh</span>
      </div>

      <FileUploader
        dialogTrigger='#uploader'
        dropZone='#uploader'
        multiple={false}
        accept='image/*'
        uploadMode='instantly'
        uploadUrl={`${nameserver}/api/upload`}
        name='file'
        visible={false}
        showFileList={false}
        inputAttr={{
          capture: 'environment',
        }}
        onDropZoneEnter={onDropZoneEvent}
        onDropZoneLeave={onDropZoneEvent}
        onUploaded={(e) => {
          const result = JSON.parse(e.request.response);
          console.log(result.url);
          onUploaded(result.url);
          setPreview(result.url);
        }}
      />
      {preview && (
        <img
          src={preview}
          style={{
            width: '100%',
            borderRadius: 12,
            marginTop: 12,
          }}
        />
      )}
    </div>
  );
};
